























import AbpBase from "../../../lib/abpbase"; 
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetDics,GetDicsByCode,SaveDicDict} from '../../../api/systemBasic'
import util from '../../../lib/util'
import model from './model.vue'

@Component({
    components:{model}
})
export default class  extends AbpBase{
    QueryString = ''
    list:any = []
    detailList:any = []
    table:any = {
        loading:false,
        detailLoading:false
    }
    modelShow = false
    modelData:any = {}
    detailInfo:any = {}
    //表格高度
    get tableHeight(){
        return window.innerHeight-200
    }
    created(){
        this.getData()
    }
    async getData(){
        this.table.loading = true
        let res = await GetDics({QueryString:this.QueryString})
        this.list  = res.objects
        this.table.loading = false
        //默认选择第一条
        this.list[0]._highlight = true;
        this.detailInfo = this.list[0]
        this.getDetail(this.list[0].pItemCode)
    }
    async getDetail(pItemCode:any){
        let res = await GetDicsByCode({code:pItemCode})
        this.detailList = res.objects;
    }
     //tab选择
    tabChange(currentRow:any,oldCurrentRow:any){
        if(currentRow){
            this.detailInfo = currentRow
            this.getDetail(currentRow.pItemCode)
        }
    }
    add(){
        this.modelData.title = '新增'
        this.modelData.info = this.detailInfo
        this.modelData.row = {}
        this.modelShow = true
    }
    async remove(row:any){
        row.status = !row.status
        let res = await SaveDicDict(row)
        if(res.status == 1){
            this.getDetail(this.detailInfo.pItemCode)
        }
    }
    edit(row:any){
        this.modelData.title = '编辑'
        this.modelData.info = this.detailInfo
        this.modelData.row = row
        this.modelShow = true
    }
    column = [
        {
            title:'名称',
            key:'pItemDesc'
        }
    ]
    detailColumn = [
        {
            title:'标题',
            key:'itemName',
        },
        {
            title:'值',
            key:'itemCode',
        },
        {
            title:'排序',
            key:'orderBy',
        },
        {
            title:'操作',
            render :(h:any,params:any) => {
                return h('div',[
                    h('Button',{
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        style:{
                            marginRight:'15px'
                        },
                        on: {
                            click: () => {
                                this.edit(params.row)
                            }
                        }
                    },'编辑'),
                    h('Button',{
                        props: {
                            type: params.row.status?'error':'primary',
                            size: 'small'
                        },
                        style:{
                            marginRight:'15px'
                        },
                        on: {
                            click: () => {
                                this.remove(params.row)
                            }
                        }
                    },params.row.status?'禁用':'启用')
                ])
            },
        }
    ]
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tempManage/dic/index.vue